import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Config from '../../../constants/Config';

import * as s from './ConfigSnippetPanel.module.scss';

const HOSTS = [
  { key: 'claude-desktop', label: 'Claude Desktop' },
  { key: 'claude-code', label: 'Claude Code' },
  { key: 'cursor', label: 'Cursor' },
  { key: 'continue', label: 'Continue.dev' },
  { key: 'zed', label: 'Zed' },
];

const PANEL_INTRO = "After generating a token above, paste it into your MCP host's config. The URL below is already filled in for this server.";

function snippetFor(key, url) {
  const placeholder = '4ga_pat_YOUR_TOKEN_HERE';
  switch (key) {
    case 'claude-desktop':
    case 'cursor':
    case 'continue':
    case 'zed':
      return JSON.stringify(
        {
          mcpServers: {
            '4gaboards': {
              url,
              headers: { Authorization: `Bearer ${placeholder}` },
            },
          },
        },
        null,
        2,
      );
    case 'claude-code':
      return `claude mcp add --transport http 4gaboards ${url} \\\n  --header "Authorization: Bearer ${placeholder}"`;
    default:
      return '';
  }
}

const ConfigSnippetPanel = React.memo(() => {
  const [t] = useTranslation();
  const [active, setActive] = useState('claude-desktop');
  const [copied, setCopied] = useState(false);

  const mcpUrl = useMemo(() => {
    const base = (typeof window !== 'undefined' && window.location && window.location.origin) || Config.SERVER_BASE_URL || '';
    return `${base}/mcp`;
  }, []);

  const snippet = useMemo(() => snippetFor(active, mcpUrl), [active, mcpUrl]);

  const copy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(snippet);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* ignore */
    }
  }, [snippet]);

  return (
    <div className={s.panel}>
      <h3>{t('common.connectAnMcpClient', 'Connect an MCP client')}</h3>
      <p className={s.intro}>{t('common.connectMcpDescription', PANEL_INTRO)}</p>

      <div className={s.tabs}>
        {HOSTS.map((h) => (
          <button type="button" key={h.key} className={active === h.key ? `${s.tab} ${s.tabActive}` : s.tab} onClick={() => setActive(h.key)}>
            {h.label}
          </button>
        ))}
      </div>

      <pre className={s.snippet}>{snippet}</pre>

      <div className={s.actions}>
        <span className={s.urlNote}>
          {t('common.mcpEndpoint', 'MCP endpoint')}: <code>{mcpUrl}</code>
        </span>
        <button type="button" className={s.copyButton} onClick={copy}>
          {copied ? t('common.copied', 'Copied!') : t('action.copy', 'Copy')}
        </button>
      </div>
    </div>
  );
});

export default ConfigSnippetPanel;
